<template>
  <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-2/5 lg:w-1/4 xl:w-1/4 mx-auto">
    <FichaAsesor />
  </div>   
</template>
<script>
import FichaAsesor from '@/components/widgets/FichaAsesor.vue'
export default {
  components: {FichaAsesor}
}
</script>